module.exports = __webpack_public_path__ + "static/media/woman-home.35de7e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/woman-home.png
// module id = 2255
// module chunks = 0